import { render, staticRenderFns } from "./CoreAbility.vue?vue&type=template&id=782d1687&scoped=true&"
import script from "./CoreAbility.vue?vue&type=script&lang=js&"
export * from "./CoreAbility.vue?vue&type=script&lang=js&"
import style0 from "./CoreAbility.vue?vue&type=style&index=0&id=782d1687&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782d1687",
  null
  
)

export default component.exports